import { c as _c } from "react/compiler-runtime";
import FaroSphereLogo from "@assets/logo/faro-sphere-xg-logo-color.svg?react";
import FaroSphereLogoMini from "@assets/logo/faro-sphere-xg-logo-mini.svg?react";
import FaroSphereLogoMiniWhite from "@assets/logo/faro-sphere-xg-logo-mini-white.svg?react";
import FaroSphereLogoWhite from "@assets/logo/faro-sphere-xg-logo-white.svg?react";
import { Box } from "@mui-wrapper";

/** Figma's `Sphere XG Logo` (`17709:23050`) variants, by the logo type */
const LOGOS = {
  full: {
    color: FaroSphereLogo,
    white: FaroSphereLogoWhite
  },
  mini: {
    color: FaroSphereLogoMini,
    white: FaroSphereLogoMiniWhite
  }
};

/**
 * @returns the styles of one of the two logos, which only shows in its own scheme
 * @param isWhite whether this is the white logo, shown in the dark scheme
 * @param height the logo's height
 */
function logoSx(isWhite, height) {
  return theme => ({
    display: isWhite ? "none" : "block",
    height: height ?? "62px",
    ...theme.applyStyles("dark", {
      display: isWhite ? "block" : "none"
    })
  });
}
/**
 * The Sphere XG logo: the colour variant in the light scheme and the white one in the dark scheme,
 * where the colour wordmark all but disappears.
 *
 * Both are rendered and the scheme picks one in CSS, the way flat-ui's `AppBar` swaps its logo, so
 * the logo follows the active colour scheme with no flash.
 */
export function SphereXgLogo(t0) {
  const $ = _c(13);
  const {
    variant: t1,
    height
  } = t0;
  const variant = t1 === undefined ? "full" : t1;
  const {
    color,
    white
  } = LOGOS[variant];
  let t2;
  if ($[0] !== height) {
    t2 = logoSx(false, height);
    $[0] = height;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== color || $[3] !== t2) {
    t3 = <Box component={color} sx={t2} />;
    $[2] = color;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== height) {
    t4 = logoSx(true, height);
    $[5] = height;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t4 || $[8] !== white) {
    t5 = <Box component={white} sx={t4} />;
    $[7] = t4;
    $[8] = white;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}